import api from "@/lib/api";

export const bulkArchive = (object, ids) => api.post("/bulk/archive", { object, ids });
export const bulkRestore = (object, ids) => api.post("/bulk/restore", { object, ids });
export const listArchived = (object) => api.get("/bulk/archived", { params: { object } });
export const massDeletePermission = () => api.get("/bulk/permission");
